/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AffectedGoals = "AttendMeeting" | "ConvenientMeetingTime" | "EmailTriage" | "FocusTask" | "FocusTime" | "Lunch" | "MeetingRelief" | "NoMeetingDay" | "PersonalObligation" | "PreferredWork" | "PrepTime" | "Task" | "TravelTime" | "WithinMeetingHours" | "WithinWorkingHours" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type AutopilotSuggestionInvite_inviteOrganizerKnob = {
    readonly suggestedInvitee: string;
    readonly affectedEventIds: ReadonlyArray<string>;
    readonly affectedGoals: ReadonlyArray<AffectedGoals | null>;
    readonly knobScore: number;
    readonly knobUrn: {
        readonly id: string;
        readonly type: UrnType | null;
        readonly value: string | null;
    };
    readonly affectedGoalsForEvents: ReadonlyArray<{
        readonly externalEventId: string;
        readonly affectedGoals: ReadonlyArray<AffectedGoals | null>;
    }>;
    readonly suggestedInviteePerson: {
        readonly primaryEmail?: string | undefined;
        readonly profile?: {
            readonly givenName: string | null;
            readonly familyName: string | null;
            readonly externalImageUrl: string | null;
        } | null | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly __typename: "InviteOrganizerKnob";
    readonly " $refType": "AutopilotSuggestionInvite_inviteOrganizerKnob";
};
export type AutopilotSuggestionInvite_inviteOrganizerKnob$data = AutopilotSuggestionInvite_inviteOrganizerKnob;
export type AutopilotSuggestionInvite_inviteOrganizerKnob$key = {
    readonly " $data"?: AutopilotSuggestionInvite_inviteOrganizerKnob$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionInvite_inviteOrganizerKnob">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affectedGoals",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AutopilotSuggestionInvite_inviteOrganizerKnob",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suggestedInvitee",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "affectedEventIds",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "knobScore",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Urn",
                "kind": "LinkedField",
                "name": "knobUrn",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AffectedGoalForEvent",
                "kind": "LinkedField",
                "name": "affectedGoalsForEvents",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    },
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestedInviteePerson",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryEmail",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "givenName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "familyName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalImageUrl",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "Person",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "InviteOrganizerKnob",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '732365182b68a71448a90da5535d61f2';
export default node;
